import { ChatReferencedResource } from '../DynamoTypes';
import { PrimaryRecordResourceCategory } from '../MedicalDataTypes';
import {
    ResolvedChatReferencedMedicalProfileFileArtifact,
    ResolvedReferencedPageFileArtifact,
    ResolvedReferencedAudioFileArtifact,
    BaseResolvedReferencedFileArtifact,
} from '../LambdaInvocationTypes';
import { MedicalProfileFiles } from '..';

type ChatReferencedResourceWithoutFileArtifact = Omit<ChatReferencedResource, 'category'> & {
    category: PrimaryRecordResourceCategory | 'care-team' | 'note';
};

export type UserMessage = {
    messageDateTime: number;
    role: 'user';
    text: string;
};

export type ModelReferencedResource =
    | ChatReferencedResourceWithoutFileArtifact
    | ResolvedChatReferencedMedicalProfileFileArtifact;

// Model message - discriminated union
export type ModelMessageProcessing = {
    messageDateTime: number;
    role: 'model';
    status: 'processing';
};

export type ModelMessageComplete = {
    messageDateTime: number;
    role: 'model';
    status?: 'complete'; // Optional for backward compat
    text: string;
    referencedResources?: ModelReferencedResource[] | null;
};

export type ModelMessageFailed = {
    messageDateTime: number;
    role: 'model';
    status: 'failed';
};

export type ModelMessage = ModelMessageProcessing | ModelMessageComplete | ModelMessageFailed;

export type Message = UserMessage | ModelMessage;

export type MedicalProfileChat = {
    chatId: string;
    medicalProfileId: string;
    createdDateTime: string;
    title?: string;
    messages: Message[];
};

export type MedicalProfileChatListItem = Omit<MedicalProfileChat, 'messages'>;

export type ListMedicalProfileChatsResponse = {
    items: MedicalProfileChatListItem[];
};

export type GetMedicalProfileChatResponse = MedicalProfileChat;

export type CreateMedicalProfileChatRequest = {
    text: string;
};

export type CreateMedicalProfileChatResponse = MedicalProfileChat;

export type CreateMedicalProfileChatMessageRequest = {
    text: string;
};

export type CreateMedicalProfileChatMessageResponse = MedicalProfileChat;

// Async response types
export type CreateMedicalProfileChatAsyncResponse = MedicalProfileChat;
export type CreateMedicalProfileChatMessageAsyncResponse = MedicalProfileChat;

export type PerformGeneralMedicalProfileSearchRequest = {
    text: string;
};

export type GroupedResolvedImageFileArtifacts = Omit<
    BaseResolvedReferencedFileArtifact,
    'medicalProfileFileArtifactId'
> & {
    type: 'image';
    page: number;
    texts: {
        text: string;
        boundingBox?: MedicalProfileFiles.BoundingBox | null;
    }[];
};

export type GeneralMedicalProfileSearchResult =
    | {
          id: string;
          category: PrimaryRecordResourceCategory | 'care-team' | 'note';
      }
    | ResolvedReferencedPageFileArtifact
    | ResolvedReferencedAudioFileArtifact
    | GroupedResolvedImageFileArtifacts;

export type PerformGeneralMedicalProfileSearchResponse = {
    searchResults: GeneralMedicalProfileSearchResult[];
};
